import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Parallax } from 'react-parallax';

import './card.css';

export default class Card extends Component{
    /*
        Card, can be parallax
        Props:
            - big: main card, is taller
            - content: JSX view or something, displayed inside the card
            - parallax: boolean, if true background image is expected
            - bg_img: if parallax is true, background image, else ignored
    */
    render(){
        console.log(this.props.parallax);
        let content;
        if(this.props.parallax)
            content =
            <Parallax
                blur={0}
                bgImage={this.props.imgPath}
                strength={this.props.big? 600 : 400}>
                {this.props.content}
            </Parallax>
        else
            content = this.props.content
        return (
            <Row className={"card-container" + (this.props.big?" big-card":"")}>
                <Col xs={12} className="card-content-container">
                    {content}
                </Col>
            </Row>
        );
    }
}
